import React from 'react'
import DailyRegimen from '../Components/DailyRegimen/DailyRegimen'

const DailyRegimenView = () => {
  return (
    <div>
        <DailyRegimen />
    </div>
  )
}

export default DailyRegimenView